import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.employeeLettersValidation = function () {
    const dictonary = {
      custom: {
        DateIssue: {
          required: () => t.t(dictEnum.LBL_Date) + t.t(dictEnum.WARN_IsRequired)
        },
        DocTypeCode: {
          required: () => t.t(dictEnum.LBL_Letter) + t.t(dictEnum.WARN_IsRequired)
        },
        TempCode: {
          required: () => t.t(dictEnum.LBL_Template) + t.t(dictEnum.WARN_IsRequired)
        },
        IssueBy: {
          required: () => t.t(dictEnum.LBL_IssueBy) + t.t(dictEnum.WARN_IsRequired)
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeLetters/S070200-EmployeeLettersValidation.js